import React from 'react'
import Navbar from '../navbar/Navbar'
import ReusableComponent from '../../components/resusable/ReusableComponent'
import { locatePeople } from '../../data/pageData'
import Footer from '../../components/Footer/Footer'
import '../About/About.css'

const LocatePeople = () => {
  return (
    <div>
      <Navbar/>
       <div className=' .about__aside-details'> 
        <div className="aboutUs__image-asideContent">
          <h1 className='about__us-title'>{locatePeople.title}</h1>
          <img src={locatePeople.image} alt="about__us-img" />
          <div className='content-component'>
            <div className="content-paragraphes">
            <p className='content1'>{locatePeople.contentLocate1}</p>
              <p className='content2'>{locatePeople.contentLocate2}</p>
            <p className='content3'>{locatePeople.contentLocate3}</p>
            <p className='content4'>{locatePeople.contentLocate4}</p>
              
            </div>

          <ReusableComponent />
          </div>
          
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default LocatePeople